"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThumbsUp = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var ThumbsUp = function ThumbsUp() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M3.6 20.8a.6.6 0 01-.6.6H.6a.6.6 0 01-.6-.6V10a.6.6 0 01.6-.6H3a.6.6 0 01.6.6v10.8zm18-11.4h-6l1.86-3.732a4.98 4.98 0 00.54-2.4V2.8A1.8 1.8 0 0016.2 1h-.168a.6.6 0 00-.564.408l-.72 2.136a2.4 2.4 0 01-1.38 1.464l-.516.204a4.872 4.872 0 00-2.28 1.92l-1.464 2.4a2.4 2.4 0 01-2.04 1.128H6v9.6h.708A4.092 4.092 0 019.6 21.4a4.092 4.092 0 002.892 1.2h7.488a2.4 2.4 0 002.22-1.512l1.284-3.204c.34-.852.514-1.76.516-2.676V11.8a2.4 2.4 0 00-2.4-2.4z"
  });
};

exports.ThumbsUp = ThumbsUp;